// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('../../accounts/store/state').Account} Account
 * @typedef {import('../../accounts/store/state').AccountConfiguration} AccountConfiguration
 */

const state = {
  /**
   * current logged-in user
   * @type {Account}
   **/
  currentUser: null,

  /**
   * account-specific configurations
   * @type {AccountConfiguration}
   **/
  currentUserConfig: null,

  // internals

  /** @type {import('rxjs').Subscription} */
  currentUserSub: null,

  /** @type {import('rxjs').Subscription} */
  deviceTokensSub: null
};

export default state;
